require('angular');
require('./PwnFMGateConstants');

module.exports = angular.module('PwnFMGateServices', ['PwnFMGateConstants'])
.provider('emailFromProcessor', function() {
    
    var $_http;
    var $_q;
    var $_filter;
    var _FMSubscriberStates;
    var _ModalAlerts;
    
    var apiURL = 'https://lp.pzwl.pl/fm/fmgate.php';
    var list = '';
    var keytype = '';
    var state = '';
    var pochodzenie = '';
    var zrodlo = '';
    var zgody_tryb = '';
    
    var fmSubscriberData = {};
    
    var ret = {
        launch: function( email ) {
            
            var d = $_q.defer();
            
            ret.getSubscriberInfo( email ).then(function( response ) {
                
                if( response.data.errors && response.data.errors.length ) {
                    
                    /* SUBSCRIBER DOES NOT EXIST */
                    if( response.data.errors[0].code == 1311 ) {
                        
                        fmSubscriberData = {};
                        d.resolve({action:'branch_of_science_needed'});
                    }
                        
                } else {
                    
                    /* SUBSCRIBER EXISTS */
                    var fmdata = response.data.data;
                    
                    ret.loadFmSubscriberData(fmdata);
                    
                    d.resolve({ action:'check_existing_subscriber', fmSubscriberData: fmSubscriberData });
                }
                
            }, function( response ) {
                
                d.reject( response );
                
            });
            
            return d.promise;
        },
        getSubscriberInfo: function( email ) {
            
            if(!list) return;
            
            return $_http({
                url: apiURL,
                method: 'POST',
                data: {
                    list: list,
                    keytype: keytype,
                    email: email,
                    request: 'subscriber/get'
                }
            });
        },
        getFmSubscriberData: function() {
            
            return fmSubscriberData;
        },
        setFmSubscriberData: function( subscriber_data ) {
            
            fmSubscriberData = anular.extend({}, subscriber_data);
            
        },
        loadFmSubscriberData: function( fmdata ) {
            
            fmSubscriberData = {};
            fmSubscriberData.state = fmdata.state;
            fmSubscriberData.email = fmdata.email;
            fmSubscriberData.pochodzenie = ret.getCustomFieldValue( 'pochodzenie', fmdata );
            fmSubscriberData["źródło"] = ret.getCustomFieldValue( 'źródło', fmdata );
            fmSubscriberData.zgoda_tele = ret.getCustomFieldValue( 'zgoda_tele', fmdata );
            fmSubscriberData.query_string = ret.getCustomFieldValue( 'query_string', fmdata );
            fmSubscriberData["dziedzina naukowa"] = ret.getCustomFieldValue( 'dziedzina naukowa', fmdata );
            fmSubscriberData.telefon = ret.getCustomFieldValue( 'telefon', fmdata );
            
        },
        getCustomFieldValue: function( cfkey, fmdata ) {
            
            return $_filter( 'filter' )( fmdata.custom_fields, { field: cfkey } )[0].value;
            
        },
        addFmSubscriber: function( email, branch_of_science, na_edition ) {
            
            return $_http({
                url: apiURL,
                method: 'POST',
                data: {
                    list: list,
                    request: 'subscriber/add',
                    keytype: keytype,
                    email: email,
                    pochodzenie: pochodzenie,
                    zrodlo: zrodlo,
                    zgody_tryb: zgody_tryb,
                    zgoda_p: 1,
                    zgoda_o: 1,
                    dziedzina_naukowa: branch_of_science,
                    pobierz_wydanie: na_edition
                }
            });
        },
        updateSubscriberCustom: function(customKey, customValue, na_edition) {
            var data = {
                list: list,
                request: 'subscriber/edit',
                keytype: keytype,
                email: fmSubscriberData.email,
                pochodzenie: pochodzenie,
                zrodlo: zrodlo,
                zgody_tryb: zgody_tryb,
                pobierz_wydanie: na_edition
            }
            
            data[customKey] = customValue;
            
            return $_http({
                url: apiURL,
                method: 'POST',
                data: data
            });
        },
        resubscribe: function(na_edition) {
            return $_http({
                url: apiURL,
                method: 'POST',
                data: {
                    request: 'subscriber/edit',
                    list: list,
                    keytype: keytype,
                    email: fmSubscriberData.email,
                    state: _FMSubscriberStates.SUBSCRIBER_STATUS_ACTIVE,
                    zgody_tryb: zgody_tryb,
                    pobierz_wydanie: na_edition
                }
            });
        },
        addUnactive: function(na_edition) {
            return $_http({
                url: apiURL,
                method: 'POST',
                data: {
                    request: 'subscriber/add',
                    list: list,
                    keytype: keytype,
                    email: fmSubscriberData.email,
                    pochodzenie: fmSubscriberData.pochodzenie,
                    zgody_tryb: zgody_tryb,
                    zgoda_p: 1,
                    zgoda_o: 1,
                    pobierz_wydanie: na_edition
                }

            });
        },
        resendActivationLink: function(na_edition) {
            
            var d = $_q.defer();
            
            $_http({
                url: apiURL,
                method: 'POST',
                data: {
                    request: 'subscriber/edit',
                    list: list,
                    keytype: keytype,
                    email: fmSubscriberData.email,
                    state: _FMSubscriberStates.SUBSCRIBER_STATUS_UNACTIVE,
                    zgody_tryb: zgody_tryb
                }
            }).then(function( response ) {
                
                if( response.data.status == 'OK' ) {
                    
                    ret.addUnactive(na_edition).then(function( response ) {
                        
                        if( response.data.status == 'OK' ) {
                            
                            d.resolve({status: 'OK'});
                        }
                        
                    }, function( response ) {
                        
                        d.reject({status: response.data.status});
                        
                    });
                    
                } else {
                    
                    d.reject({status: response.data.status});
                }
                
            }, function( response ) {
                
                d.reject( response );
                
            });
            
            return d.promise;
        }
    };
    
    return {
        setFmgateData: function( config ) {
            list = config.list;
            keytype = config.keytype;
            pochodzenie = config.pochodzenie;
            zgody_tryb = config.zgody_tryb;
            zrodlo = config.zrodlo;
            return this;
        },
        $get: ['$http', '$q', '$filter', 'FMSubscriberStates', 'ModalAlerts', function($http, $q, $filter, FMSubscriberStates, ModalAlerts) {
            _FMSubscriberStates = FMSubscriberStates;
            _ModalAlerts = ModalAlerts;
            $_http = $http;
            $_q = $q;
            $_filter = $filter;
            return ret;
        }]
    }
    
}).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.defaults.transformRequest = function(data){
    if (data === undefined) {
      return data;
    }
    return jQuery.param(data);
  };
  $httpProvider.defaults.headers.post['Content-Type'] = ''
    + 'application/x-www-form-urlencoded; charset=UTF-8';
}]);


//////////////////
// WEBPACK FOOTER
// ./vendor/fm_subscription/js/PwnFMGate.service.js
// module id = 29
// module chunks = 0